import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { RechazosTracesParteIViewModel, TNTRetrievalAttachmentViewModel } from '../rechazostraces.types';
import { RechazosTracesService } from '../rechazostraces.service';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { NavMenuService } from '../../../../core/components/navmenu/navmenu.service';

@Component({
    selector: 'app-rechazostraces-wrapper-parte-i',
    templateUrl: './rechazostraces-wrapper-parte-i.component.html',
})
export class RechazosTracesWrapperParteIComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    tracesParteI: RechazosTracesParteIViewModel | null;
    formGroup: FormGroup;

    listUrl = '/importacion/rechazostraces';
    private CHEDPP: string | null = '';

    isRechazo = false;

    activatedRouteData$ = this.activatedRoute.data.subscribe(data => {
        this.isRechazo = data['isRechazo'] === true;
    });

    activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        this.CHEDPP = params.get('CHEDPP');
        if (this.CHEDPP) {
            this.getRechazoTracesParteI(this.CHEDPP);
        }
    });

    constructor(
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private globalService: GlobalService,
        protected rechazosTracesService: RechazosTracesService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private navMenuService: NavMenuService,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.preparePresentation();
    }

    private preparePresentation(): void {
        this.buildForm();
    }

    private buildForm(): void {
        this.formGroup = this.fb.group({
            basic: this.fb.group({
                NombreExportador: '',
                PaisExportador: '',
                NombreImportador: '',
                PaisImportador: '',
                RefDocAduanero: '',
                Referencia: '',
                //NombrePCF: '',
                //PaisPCF: '',
                NombrePIF: '',
                PaisPIF: '',
                NombreOperador: '',
                PaisOperador: '',
                Documentos: null,
                NotificacionPrevia: null,
                NombreLugarDestino: '',
                PaisLugarDestino: '',
                NombreMedioTrans: '',
                TipoMedioTrans: '',
                PaisMedioTrans: '',
                DocumentoMedioTrans: '',
                PaisOrigen: this.tracesParteI?.PaisOrigen,
                PaisExpedicion: '',
                NumeroContenedor: '',
                NumeroPrecinto: '',
                PrecintoOficial: '',
                Finalidad: '',
                Embalajes: [],
                Productos: [],
            }),
        });
    }

    private getRechazoTracesParteI(CHEDPP: string): void {
        this.rechazosTracesService
            .getRechazoTracesParteI(CHEDPP)
            .pipe(
                tap((rechazoTracesParteI: RechazosTracesParteIViewModel) => {
                    this.tracesParteI = rechazoTracesParteI;
                    if (this.tracesParteI !== null) {
                        this.tracesParteI.CHEDPP = this.CHEDPP! || '';
                        if (this.isRechazo) {
                            this.navMenuService.updateMenuServiceForRechazoTraces(this.tracesParteI?.CHEDPP);
                        } else {
                            this.navMenuService.updateMenuServiceForTrasladoTraces(this.tracesParteI?.CHEDPP);
                        }
                    }
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.formGroup.disable();
                    return of([]);
                }),
            )
            .subscribe();
    }

    onBack(): void {
        this.router.navigate([this.listUrl]);
    }

    onDownload(model: TNTRetrievalAttachmentViewModel): void {
        this.rechazosTracesService.getDocumentoRechazoTraces(model).subscribe({
            next: res => {
                this.OpenDownloadedFile(res);
            },
            error: error => {
                this.catchServerError(error);
            },
        });
    }
}
